(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $3230f6deb9d836c7$var$accordions = {
    init: function() {
        var accordions = document.querySelectorAll('.accordion-item');
        if (!accordions) return;
        accordions.forEach(function(accordion) {
            var btn = accordion.querySelector('button');
            var content = accordion.querySelector('.accordion');
            if (!btn || !content) return;
            accordion.addEventListener('click', function() {
                var expanded = (btn === null || btn === void 0 ? void 0 : btn.getAttribute('aria-expanded')) === 'true';
                btn === null || btn === void 0 ? void 0 : btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
                if (expanded) content === null || content === void 0 ? void 0 : content.removeAttribute('hidden');
                else content === null || content === void 0 ? void 0 : content.setAttribute('hidden', 'true');
            });
        });
    }
};
var $3230f6deb9d836c7$export$2e2bcd8739ae039 = $3230f6deb9d836c7$var$accordions;


var $59bdea93f29f00f1$var$nav = {
    init: function() {
        var hamburger = document.querySelector('.hamburger');
        if (!hamburger) return;
        var svg = hamburger.querySelector('svg');
        var container = document.querySelector('.nav-toggle');
        var links = container.querySelectorAll('a');
        hamburger.addEventListener('click', function() {
            if (svg.classList.contains('lucide-menu')) {
                svg.classList.remove('lucide-menu');
                svg.classList.add('lucide-x');
                container.classList.remove('hidden');
            } else $59bdea93f29f00f1$var$nav.closeNav(svg, container);
        });
        links.forEach(function(link) {
            link.addEventListener('click', function() {
                $59bdea93f29f00f1$var$nav.closeNav(svg, container);
            });
        });
    },
    closeNav: function(svg, container) {
        svg.classList.add('lucide-menu');
        svg.classList.remove('lucide-x');
        container.classList.add('hidden');
    }
};
var $59bdea93f29f00f1$export$2e2bcd8739ae039 = $59bdea93f29f00f1$var$nav;


var $847553d13b80c4b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function App() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, App);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(App, [
        {
            key: "initCore",
            value: function initCore() {
                (0, $3230f6deb9d836c7$export$2e2bcd8739ae039).init();
                (0, $59bdea93f29f00f1$export$2e2bcd8739ae039).init();
            }
        }
    ]);
    return App;
}();
function $847553d13b80c4b3$var$LoadApp() {
    var app = new $847553d13b80c4b3$export$2e2bcd8739ae039();
    app.initCore();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $847553d13b80c4b3$var$LoadApp);
else $847553d13b80c4b3$var$LoadApp();

})();
//# sourceMappingURL=_app.js.map
